// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{margin:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:var(--font-family)}code{font-family:var(--font-family-mono)}*{box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,KACC,QAAA,CACA,kCAAA,CACA,iCAAA,CACA,8BAAA,CAGD,KACC,mCAAA,CAGD,EACC,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
